import React from 'react';
import CustomModal from '../../../../core/components/core/Util/Modal/CustomModal';

/**
 * Modal de confirmação de importação.
 *
 * @param {boolean}  show             - Exibir o modal
 * @param {Array}    selectedTypes    - Tipos selecionados (values)
 * @param {Function} getTypeLabel     - Converte value → label
 * @param {Function} onConfirm        - Callback ao confirmar
 * @param {Function} onCancel         - Callback ao cancelar/fechar
 */
const ConfirmImportModal = ({ show, selectedTypes, getTypeLabel, onConfirm, onCancel }) => {
  return (
    <CustomModal
      show={show}
      title="Confirmação de Importação"
      content={
        <div>
          Deseja realizar as seguintes importações:{' '}
          <strong>{selectedTypes.map(getTypeLabel).join(', ')}</strong>?
        </div>
      }
      confirmButtonText="Importar"
      cancelButtonText="Cancelar"
      handleConfirm={onConfirm}
      handleCancel={onCancel}
      handleClose={onCancel}
    />
  );
};

export default ConfirmImportModal;
